export default __webpack_public_path__ + "static/media/default.d03531fb0a5779fd66019badd32297de.svg";